module.exports = __webpack_public_path__ + "static/producteev-e8e8a1a4fe6fdbecda918bd7ec29f542.svg";